import React from 'react'

export const UserCountBanner = ({ data }: { data: any }) => {
  return (
    <div className="mt-[30px] text-center relative px-10">
      <img
        className="top-1/2 -translate-y-1/2 left-[14px] absolute"
        src="/quiz/icons/user.svg"
        alt="vector"
      />
      <h2
        className="text-[48px] [&_span]:relative user-text [&_span]:inline-block [&_span]:top-[-3px] leading-[1.2] tracking-[-0.01em] font-bold"
        dangerouslySetInnerHTML={{ __html: data.numbers }}
      ></h2>
      {data.text && <p className="opacity-60 font-medium">{data.text}</p>}
      <img
        className="top-1/2 -translate-y-1/2 right-[14px] absolute scale-x-[-1]"
        src="/quiz/icons/user.svg"
        alt="vector"
      />
    </div>
  )
}
